import {slideToggle, slideUp, index} from '../utility/utils';

export const InitTeamCards = () => {
  const teamCards = document.querySelectorAll('.type_detailed .team__card');

  if(teamCards){
    teamCards.forEach(card => {
      const trigger = card.querySelector('.team__trigger');
      const bio = card.querySelector('.team__bio');

      if(bio && trigger){
        card.accordion = new tdTeamCard(card);
      }
    });
  }
}

class tdTeamCard {
  constructor(el) {
    this.el = el;
    this.trigger = el.querySelector('.team__trigger');
    this.bio = el.querySelector('.team__bio');
    this.active = false;

    if(this.bio && this.trigger){
      this.watchTriggerClick();
    }
  }

  watchTriggerClick() {
    this.trigger.addEventListener('click', () => {
      this.active = !this.active;

      if(this.active){
        this.trigger.classList.add('active');
        this.bio.classList.add('active');
        this.bio.setAttribute('aria-hidden', 'false');
      }
      else {
        this.trigger.classList.remove('active');
        this.bio.classList.remove('active');
        this.bio.setAttribute('aria-hidden', 'true');
      }

      slideToggle(this.bio);
    });
  }
}

